import type { FC, ReactNode } from "react";

export type ProfileFieldItem = {
  label: string;
  value: ReactNode;
};

export type ProfileRecordItem = {
  key: string;
  title?: string;
  fields: ProfileFieldItem[];
};

type ResponsiveProfileRecordsProps = {
  records: ProfileRecordItem[];
};

export const ResponsiveProfileRecords: FC<ResponsiveProfileRecordsProps> = ({
  records,
}) => (
  <div className="md:hidden flex flex-col divide-y divide-gray-100">
    {records.map((record) => (
      <div key={record.key} className="flex flex-col gap-2 py-3 first:pt-0">
        {record.title ? (
          <div className="font-semibold text-gray-font">{record.title}</div>
        ) : null}
        {record.fields.map((field) => (
          <div key={field.label} className="flex flex-col gap-0.5">
            <span className="font-semibold text-gray-font">{field.label}</span>
            <div className="break-words">{field.value}</div>
          </div>
        ))}
      </div>
    ))}
  </div>
);

type ProfileFieldCellProps = {
  label: string;
  value: ReactNode;
  className?: string;
};

export const ProfileFieldCell: FC<ProfileFieldCellProps> = ({
  label,
  value,
  className = "",
}) => (
  <div className={`flex flex-col gap-0.5 ${className}`.trim()}>
    <span className="font-semibold text-gray-font">{label}</span>
    <div className="text-sm break-words">{value}</div>
  </div>
);
